import styled from "@emotion/styled";

export const ModalContent = styled.div({
    maxWidth: 450,
});
